import { createContext, useContext, useState, useEffect } from 'react';

const UserRoleContext = createContext();

export const useUserRole = () => useContext(UserRoleContext);

export const UserRoleProvider = ({ children }) => {
  const [userRole, setUserRole] = useState(JSON.parse(sessionStorage.getItem('roles')) || []);
  const [isAuthenticated, setIsAuthenticated] = useState(Boolean(sessionStorage.getItem('token')));
  const [merchantId, setMerchantId] = useState(sessionStorage.getItem('merchantId') || null);

  const isAdmin = () => userRole.includes('Admin');
  const isChargebackOfficer = () => userRole.includes('ChargebackOfficer');

  const updateUserRole = (role) => {
    setUserRole(role);
    sessionStorage.setItem('roles', JSON.stringify(role));
  };

  const updateIsAuthenticated = (auth) => {
    setIsAuthenticated(auth);
    if (!auth) {
      sessionStorage.removeItem('token');
    }
  };

  const updateMerchantId = (id) => {
    setMerchantId(id);
    sessionStorage.setItem('merchantId', id);
  };

  useEffect(() => {
    const token = sessionStorage.getItem('token');
    if (token) {
      setIsAuthenticated(true);
    }
  }, []);

  return (
    <UserRoleContext.Provider
      value={{
        userRole,
        setUserRole: updateUserRole,
        isAuthenticated,
        setIsAuthenticated: updateIsAuthenticated,
        isAdmin,
        isChargebackOfficer,
        merchantId,
        setMerchantId: updateMerchantId,
      }}
    >
      {children}
    </UserRoleContext.Provider>
  );
};